import CrownIcon from 'assets/Icons/CrownIcon';
import { useRouter } from 'next/router';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';

import { user } from '@/atoms/user';
import { isSubscriptionActive } from '@/utils/index';
import { User } from '@/utils/interfaces/User';

interface Props {
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SubscribeButton: React.FC<Props> = ({ setShowDropDown, setOpen }) => {
  const router = useRouter();

  const userData = useRecoilValue<User | undefined>(user);

  return (
    <ShouldRender check={!isSubscriptionActive(userData)}>
      <div className='px-5 w-full'>
        <button
          onClick={() => {
            setShowDropDown(false);
            router.push('/subscription');
            setOpen(false);
          }}
          className=' flex items-center justify-center  w-full bg-gradient-to-br from-[#593A1A] to-[#D3A984] rounded-lg '
        >
          <div
            className='flex items-center justify-center gap-2 p-2 w-full m-px rounded-lg'
            style={{
              background:
                'linear-gradient(152deg, #1B1815 9.93%, #1E1A17 90.07%)',
            }}
          >
            <CrownIcon className='w-6 h-6' />
            <p className='text-xs/4 text-[#D3A984] font-medium'>
              Subscribe & Save Extra 30%
            </p>
          </div>
        </button>
      </div>
    </ShouldRender>
  );
};

export default SubscribeButton;
